// extracted by mini-css-extract-plugin
export default {"tooltipBlock":"style_tooltipBlock__wmfLV","header":"style_header__A0Zb7","tooltipBlockContent":"style_tooltipBlockContent__YopEI"};